<template>
    <div class="min-w-[500px] overflow-auto">
        <div class="flex flex-wrap sm:flex-nowrap items-center justify-between my-4 lg:my-8">
            <!-- title -->
            <div class="flex-grow flex items-center">
                <svg viewBox="0 0 40 40" class="block w-8 h-8 stroke-current text-navy"
                    xmlns="http://www.w3.org/2000/svg">
                    <g transform="matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)">
                        <path d="M6.750 9.750 A5.250 5.250 0 1 0 17.250 9.750 A5.250 5.250 0 1 0 6.750 9.750 Z"
                            fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
                        <path d="M18.913,20.876a9.746,9.746,0,0,0-13.826,0" fill="none" stroke-linecap="round"
                            stroke-linejoin="round" stroke-width="1"></path>
                        <path d="M0.750 12.000 A11.250 11.250 0 1 0 23.250 12.000 A11.250 11.250 0 1 0 0.750 12.000 Z"
                            fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"></path>
                    </g>
                </svg>

                <span class="ml-2 text-navy font-bold leading-7 text-2xl">
                    Profile
                </span>
            </div>

            <inertia-link :href="route('logout')" method="post" as="button"
                class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">
                Log Out
            </inertia-link>

        </div>

        <flash-message />

        <div class="py-8 px-5 shadow border-b border-gray-200 mt-8 bg-white mb-10">
            <form @submit.prevent="update">
                <div class="p-2 lg:mx-4 md:w-1/2">
                    <label class="block text-sm font-medium text-gray-700" for="first_name">
                        First name
                    </label>

                    <input
                        class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                        id="first_name" type="text" autocomplete="first_name" v-model="form.first_name">

                    <div class="text-red-600" v-if="form.errors.first_name">{{ form.errors.first_name }}</div>
                </div>

                <div class="p-2 lg:mx-4 md:w-1/2">
                    <label class="block text-sm font-medium text-gray-700" for="last_name">
                        Last name
                    </label>

                    <input
                        class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                        id="last_name" type="text" autocomplete="last_name" v-model="form.last_name">

                    <div class="text-red-600" v-if="form.errors.last_name">{{ form.errors.last_name }}</div>
                </div>

                <div class="p-2 lg:mx-4 md:w-1/2">
                    <label class="block text-sm font-medium text-gray-700" for="email">
                        Email
                    </label>

                    <span class="block mt-2 text-sm">{{ $page.props.auth.user.email }}</span>
                </div>

                <div class="flex justify-start p-2 lg:mx-4">
                    <button type="submit"
                        class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        :disabled="form.processing">
                        Change Name
                    </button>
                </div>
            </form>
        </div>

        <div class="py-8 px-5 shadow border-b border-gray-200 mt-8 bg-white mb-10">
            <form @submit.prevent="change">
                <div class="p-2 mt-4 lg:mx-4 md:w-1/2">
                    <label class="block text-sm font-medium text-gray-700" for="current">
                        Current Password
                    </label>

                    <input
                        class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                        id="current" type="password" required v-model="form.current">

                    <div class="text-red-600" v-if="form.errors.current">{{ form.errors.current }}</div>
                </div>

                <div class="p-2 lg:mx-4 md:w-1/2">
                    <label class="block text-sm font-medium text-gray-700" for="password">
                        New password
                    </label>

                    <input
                        class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                        id="password" type="password" required v-model="form.password">

                    <div class="mt-2 text-xs font-medium">
                        Your password must be at least 8 characters long with 1 letter, 1 number and 1 special character
                        at a minimum.
                    </div>

                    <div class="text-red-600" v-if="form.errors.password">{{ form.errors.password }}</div>
                </div>

                <div class="p-2 lg:mx-4 md:w-1/2">
                    <label class="block text-sm font-medium text-gray-700" for="password_confirmation">
                        Confirm New Password
                    </label>

                    <input
                        class="mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md"
                        id="password_confirmation" type="password" required v-model="form.password_confirmation">

                    <div class="text-red-600" v-if="form.errors.password_confirmation">{{
                        form.errors.password_confirmation }}</div>
                </div>

                <div class="flex justify-start p-2 lg:mx-4">
                    <button type="submit"
                        class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        :disabled="form.processing">
                        Change Password
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import AppLayout from "@/Layouts/App";
import { useForm } from '@inertiajs/inertia-vue3'

export default {
    name: 'profileManager',
    layout: [AppLayout],
    components : {
    },

    setup() {
        const form = useForm({
            first_name: "",
            last_name: "",
            current: "",
            password: "",
            password_confirmation: "",
        })

        return { form }
    },


  created() {
      this.form.first_name = this.$page.props.auth.user.first_name;
      this.form.last_name = this.$page.props.auth.user.last_name;
  },

    methods: {
        update() {
            this.form.put(route('app.profile.update'));
        },

        change() {
            this.form.put(route('app.profile.change-password'), {
                onSuccess: () => {
                    this.form.current = "";
                    this.form.password = "";
                    this.form.password_confirmation = "";
                }
            })
        },
    }
}
</script>
